"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = iteratee;

var _underscore = _interopRequireDefault(require("./underscore.js"));

var _baseIteratee = _interopRequireDefault(require("./_baseIteratee.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External wrapper for our callback generator. Users may customize
// `_.iteratee` if they want additional predicate/iteratee shorthand styles.
// This abstraction hides the internal-only `argCount` argument.
function iteratee(value, context) {
  return (0, _baseIteratee.default)(value, context, Infinity);
}

_underscore.default.iteratee = iteratee;